module.exports = __webpack_public_path__ + "static/img/metzexpress.bee7361.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/metzexpress.png
// module id = DQJM
// module chunks = 1